import Alert from '@mui/material/Alert';
import { flashMessageSlice } from '_services/Redux/FlashMessage/FlashMessageSlice';
import useFlash from '_services/Redux/FlashMessage/Selector/useFlash';
import { FlashMessageShape } from '_services/Redux/FlashMessage/type';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import './FlashMessages.scss';

/**
 * Component displaying messaged from the redux state
 * Handles also removing messages after the given duration of each message
 *
 * @returns JSX.Element
 */
const FlashMessages = (): React.JSX.Element => {
    const dispatch = useDispatch();
    const { messages } = useFlash();
    const { removeMessage } = flashMessageSlice.actions;
    const { t } = useTranslation();
    /**
     * Removes each message after the given duration.
     * Defaults to 5000 if duration is not set
     */
    messages.forEach((message) => {
        const duration = message.duration ?? 5000;
        setTimeout(() => {
            if (message.id) {
                dispatch(removeMessage(message.id));
            }
        }, duration);
    });

    const handleRemove = (message: FlashMessageShape) => {
        if (message.id) {
            dispatch(removeMessage(message.id));
        }
    };

    return (
        <>
            {messages.map((message) => (
                <Alert
                    className="kan-notice-message"
                    severity={message.type}
                    key={message.id}
                    onClick={() => handleRemove(message)}
                >
                    {t(message.text as unknown as TemplateStringsArray)}
                </Alert>
            ))}
        </>
    );
};

export default FlashMessages;
